import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRerunIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.685 9C19.685 9 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M19.685 9L16.953 8.26795M19.685 9L20.4171 6.26795",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8901 10.8341L12.0075 10.0118C11.5526 9.8128 11.1894 9.44932 10.9905 8.99408L10.1689 7.10994C10.1046 6.96335 9.89856 6.96335 9.83425 7.10994L9.0126 8.99408C8.81373 9.44932 8.45054 9.8128 7.99565 10.0118L6.10941 10.8353C5.96413 10.8985 5.96294 11.1058 6.10941 11.1702L8.0278 12.0187C8.4815 12.2201 8.8435 12.5848 9.03999 13.0412L9.83545 14.8896C9.89856 15.0362 10.1069 15.0374 10.1701 14.8896L10.9905 13.0079C11.1894 12.5526 11.5526 12.1891 12.0075 11.9901L13.8901 11.1678C14.0366 11.1035 14.0366 10.8973 13.8901 10.8329V10.8341Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9451 14.9171L15.0037 14.5059C14.7763 14.4064 14.5947 14.2247 14.4953 13.997L14.0844 13.055C14.0523 12.9817 13.9493 12.9817 13.9171 13.055L13.5063 13.997C13.4069 14.2247 13.2253 14.4064 12.9978 14.5059L12.0547 14.9177C11.9821 14.9492 11.9815 15.0529 12.0547 15.0851L13.0139 15.5094C13.2407 15.6101 13.4218 15.7924 13.52 16.0206L13.9177 16.9448C13.9493 17.0181 14.0535 17.0187 14.085 16.9448L14.4953 16.0039C14.5947 15.7763 14.7763 15.5946 15.0037 15.4951L15.9451 15.0839C16.0183 15.0517 16.0183 14.9486 15.9451 14.9165V14.9171Z",
			fill: "currentColor"
		})
	]
});
export default SvgRerunIcon;
